class AccountDetails {
  constructor(params) {
    this.username = params.username;
    this.email = params.email;
    this.phoneNumber = params.phoneNumber;
    this.iDinActivationDate = params.iDinActivationDate;
    this.iDinActive = params.iDinActive;
    this.loginActive = params.loginActive;
    this.loginInfo = params.loginInfo;
    this.usernameAlreadyExists = false;
    this.digitalNewsletterActive = params.digitalNewsletterActive;
    this.announcementEmailActive = params.announcementEmailActive;
    this.paymentMethod = params.paymentMethod;
    this.paymentMethodExcess = params.paymentMethodExcess;
    return this;
  }

  setUsernameAlreadyExists(payload) {
    this.usernameAlreadyExists = payload;
    return this;
  }
}
export { AccountDetails as default };
